<template>
<v-container>

    <u-animate-container>
        <u-animate name="bounceInRight" delay="0s" duration="2s" :iteration="1" :offset="0" animateClass="animated" :begin="false">
            <v-flex xs12>
                <v-container>
                    <v-layout row wrap>
                        <v-flex sm3 xs12 md3 lg3 pa-1>
                            <statscard color="green" icon="mdi-file-multiple" title="Históricos de papeles" :value="disponibles" sub-icon="mdi-file-document" sub-text="" />
                        </v-flex>
                        <v-flex sm3 xs12 md3 lg3  pa-1>
                            <statscard  color="orange" icon="mdi-file-document" title="Papeles usados" :value="usados" sub-icon="mdi-file-document" sub-text="" />
                        </v-flex>
                        <v-flex sm3 xs12 md3 lg3  pa-1>
                            <statscard color="blue" icon="mdi-file-hidden" title="Papeles Digitales Usados" :value="digital_usados" sub-icon="mdi-file-document" sub-text=""  />
                        </v-flex>
                        <v-flex sm3 xs12 md3 lg3  pa-1>
                            <statscard color="blue" icon="mdi-file-hidden" title="Papeles Digitales Disponibles" :value="digital_disponible" sub-icon="mdi-file-document" sub-text=""  />
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </u-animate>
    </u-animate-container>

    <v-layout>
        <v-flex xs12>
            <v-card min-height="200px">
                <v-flex xs12>
                    <v-scroll-y-transition mode="out-in">
                        <v-card v-if="!checkRuap">
                            <v-card-title primary-title class="grey lighten-4">
                                <v-tooltip top>
                                    <v-btn slot="activator" dark icon class="mx-0">
                                        <v-icon color="red">help</v-icon>
                                    </v-btn>
                                    <span>Papel/Seguridad</span>
                                </v-tooltip>
                                <h3 class="headline mb-0">Papeles Solicitados</h3>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" dark class="mb-2" @click="dialogNuevaSolicitud = true">Nueva Solicitud</v-btn>
                            </v-card-title>
                            <v-card-title primary-title class="grey lighten-4">
                                <v-spacer></v-spacer>
                                <v-text-field
                                    @change="onChange"
                                    slot="input"
                                    v-model="search"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <div>
                                    <v-data-table
                                        :headers="headers"
                                        :items="papeles"
                                        :pagination.sync="pagination"
                                        :total-items="total"
                                        :rows-per-page-items="rowsPerPageItems"
                                        :loading="loading"
                                        class="elevation-0"
                                    >
                                        <template v-slot:items="props">
                                            <td class="text-xs-center">{{ props.item.cpc }}</td>
                                            <td class="text-xs-center">{{ props.item.cantidad }}</td>
                                            <td class="text-xs-center">
                                                <v-chip v-if="props.item" :color="props.item.status == 'SOLICITUD' ? 'green' : props.item.status == 'ANULADO' ? 'red' : props.item.status == 'POR ENTREGAR' ? 'orange' : 'blue'" text-color="white">{{ props.item.status }}</v-chip>
                                            </td>
                                            <td class="text-xs-center">{{ props.item.digital ? 'SI' : 'NO' }}</td>
                                            <td class="text-xs-center">{{ Number(Number(montoDiferenciaPago(props)).toFixed(2)).toLocaleString('es-VE') }}</td>
                                            <td class="text-xs-center">{{ props.item.created_at }}</td>
                                            <!-- <td class="text-xs-center"><v-chip :color="statusRap(props.item) == null ? 'orange' : statusRap(props.item) == false ? 'red' : 'green'" text-color="white">{{ statusRap(props.item) == null ? 'EN REVISIÓN' : statusRap(props.item) == false ? 'DEVUELTO' : 'VALIDADO' }}</v-chip></td> -->
                                            <td class="justify-center layout px-0">
                                            <v-tooltip top v-if="props.item.status == 'SOLICITUD'">
                                                <v-btn @click="efectuarPago(props)" slot="activator" icon class="mx-0" v-if="diferenciaPago(props)">
                                                    <v-icon color="primary">account_balance_wallet</v-icon>
                                                </v-btn>
                                                <span>Efectuar Otro Pago</span>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <v-btn @click="visulizarPapeles(props)" v-if="props.item.status == 'POR ENTREGAR' || props.item.status == 'ENTREGADO'" slot="activator" icon class="mx-0" >
                                                    <v-icon color="primary">description</v-icon>
                                                </v-btn>
                                                <span>Papeles</span>
                                            </v-tooltip>
                                            <!-- <v-tooltip top>
                                                <v-btn v-if="props.item.status == 'SOLICITUD' || props.item.status == 'EN PROCESO'" @click="deleteItem(props.item)" slot="activator" icon class="mx-0" >
                                                    <v-icon color="red">delete</v-icon>
                                                </v-btn>
                                                <span>Eliminar Solicitud</span>
                                            </v-tooltip> -->
                                            </td>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-scroll-y-transition>
                </v-flex>
            </v-card>
        </v-flex>
    </v-layout>

    <v-dialog v-model="loading" hide-overlay persistent width="300">
        <v-card color="primary" dark>
            <v-card-text>
                Porfavor Espere...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

        <v-dialog v-model="payActivate" width="600" persistent>
            <v-flex xs12>
            <v-card>
                <v-form ref="formpago" v-model="validpago" lazy-validation>
                    <v-card-title>
                        <h3 class="headline mb-0"><span style="color: #9C1A1A">Efectuar Pago</span></h3>
                    </v-card-title>
                   <v-card-text>
                        <!-- <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-flex xs12 sm4>
                                    <v-text-field
                                        ref="rif"
                                        v-model="form.rif"
                                        prepend-icon="featured_video"
                                        label="RIF"
                                        :rules="[v => !!v || 'RIF es requerido']"
                                        required
                                        mask="A-########-#"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm8>
                                    <v-text-field
                                        ref="razonsocial"
                                        v-model="form.razon_social"
                                        prepend-icon="person"
                                        label="Razon social"
                                        :rules="[v => !!v || 'Razon social es requerido']"
                                        required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex> -->

                        <!-- <v-flex xs12>
                            <v-text-field
                                ref="direccionfiscal"
                                v-model="form.direccion_fiscal"
                                prepend-icon="domain"
                                label="Direccion Fiscal"
                                :rules="[v => !!v || 'Direccion Fiscal es requerido']"
                                required
                            ></v-text-field>
                        </v-flex> -->

                        <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-flex xs12 sm6>
                                    <v-select
                                        prepend-icon="account_balance_wallet"
                                        :items="wayToPay"
                                        v-model="form.way_to_pay"
                                        @change="changeWayToPay"
                                        label="Método de pago"
                                        :rules="[v => !!v || 'Método de pago es requerido']"
                                        required
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12 sm6>
                                    <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                                        <div class="v-input__prepend-outer">
                                        <div class="v-input__icon v-input__icon--prepend">
                                            <i aria-hidden="true" class="v-icon material-icons theme--light">credit_card</i>
                                        </div>
                                        </div>
                                        <div class="v-input__control">
                                        <div class="v-input__slot">
                                            <div class="v-text-field__slot">
                                            <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto a pagar</label>
                                            <vue-numeric read-only currency="BsS" :value="form.amount" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                                            </div>
                                        </div>
                                        <div class="v-text-field__details">
                                            <div class="v-messages theme--light">
                                            <div class="v-messages__wrapper">
                                                Precio con IVA + SERVICIO incluido
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12>
                            <v-select
                                v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                prepend-icon="account_balance"
                                :items="banks"
                                v-model="form.bank_id"
                                item-text="name"
                                item-value="id"
                                label="Banco"
                                :rules="[v => !!v || 'Banco de pago es requerido']"
                                required
                            ></v-select>
                        </v-flex>

                        <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                        ref="number"
                                        v-model="form.number"
                                        prepend-icon="remove"
                                        label="Número de transacción"
                                        mask="###############"
                                        :rules="[v => !!v || 'Número de transacción es requerido']"
                                        required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-menu
                                        ref="menu"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="menu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        min-width="290px"
                                        :return-value.sync="date"
                                    >
                                        <v-text-field
                                            slot="activator"
                                            label="Fecha"
                                            v-model="computedDateFormattedFecha"
                                            hint="DD/MM/YYYY formato"
                                            prepend-icon="event"
                                            :rules="[v => !!v || 'Fecha es requerido']"
                                            required
                                            readonly
                                        ></v-text-field>
                                        <v-date-picker :max="new Date().toISOString().slice(0,10)" v-model="form.payment_date" no-title scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                        <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12>
                            <input hidden type="file" ref="fileInput" @change="processFile($event)">
                            <v-text-field
                                :rules="[v => !!v || 'Comprobante de pago es requerido']"
                                ref="document"
                                v-model="nameImg"
                                @click.native="onFocus"
                                prepend-icon="attach_file"
                                label="Comprobante de pago"
                            ></v-text-field>
                        </v-flex>

                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary darken-1" @click="closePay">Cerrar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn :loading="loading" color="primary" @click="confirmData">Confirmar Pago</v-btn>
                </v-card-actions>
                </v-form>
            </v-card>
        </v-flex>
        </v-dialog>

        <v-dialog v-if="dialogNuevaSolicitud" v-model="dialogNuevaSolicitud" width="800" persistent>
            <FormSolicitudPapel :banks="banks" :user="user" :loading="loading" v-on:loadingResponse="loading = $event" v-on:closepapeldialog="dialogNuevaSolicitud = $event" v-on:responseForm="responseForm($event)"/>
        </v-dialog>

        <v-dialog v-model="dialogVisualizarPapers" width="600" persistent>
            <v-card>
                <v-card-title>
                    <h3 class="headline mb-0"><span style="color: #9C1A1A">Papeles Solicitados</span></h3>
                </v-card-title>
                <v-card-text>
                    <p>Cantidad de papeles: {{ cantidadP }} </p>
                <v-list two-line>
                    <template v-for="item in papersP.security_paper_unionize">
                        <v-list-tile :key="item.id" >
                            <v-list-tile-content>
                                <v-list-tile-title v-html="papersP.digital ? item.security_paper.papel : 'MI' + item.security_paper.papel"></v-list-tile-title>
                                <v-list-tile-sub-title v-html="item.usado ? 'USADO' : 'NO USADO'"></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary darken-1" @click="dialogVisualizarPapers = false">Cerrar</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

</v-container>
</template>


<script>
import Form from 'vform'
import axios from 'axios'
import VueNumeric from 'vue-numeric'
import { mapGetters } from 'vuex'
import { UAnimateContainer, UAnimate } from 'vue-wow'
import statscard from '~/components/material/StatsCard.vue'
import FormSolicitudPapel from '~/pages/cliente/FormSolicitudPapel.vue'

export default {

    name: "papeles-view",

    components: {
        UAnimateContainer,
        UAnimate,
        statscard,
        VueNumeric,
        FormSolicitudPapel
    },

    data () {
      return {
        precio_delivery: 0,
        cantidadP: 0,
        papersP: [],
        papeles: [],
        banks: [],
        search: '',
        total: 0,
        disponibles: '0',
        digital_disponible: '0',
        digital_usados: '0',
        usados: '0',
        date: null,
        fecha: null,
        menu: false,
        valid: false,
        validpago: false,
        validConciliacion: false,
        editvalidate: false,
        dialog: false,
        loading: false,
        checkRuap: false,
        payActivate: false,
        dialogNuevaSolicitud: false,
        dialogVisualizarPapers: false,
        wayToPay: ['TRANSFERENCIA'],
        nameImg: '',
        pagination: {},
        form: new Form({
            cpc: '',
            way_to_pay: 'TRANSFERENCIA',
            number: null,
            ruap_id: null,
            payment_date: '',
            observations: '',
            file: '',
            document: '',
            agreement: false
        }),
        headers: [
          { text: 'CPC', align: 'center',value: 'cpc', sortable: false },
          { text: 'CANTIDAD', align: 'center' , value: '', sortable: false },
          { text: 'ESTATUS', align: 'center' , value: 'status', sortable: false },
          { text: 'PAPEL DIGITAL', align: 'center' , value: 'digital', sortable: false },
          { text: 'DIFERENCIA DE MONTO', align: 'center' , value: 'diferencia_pago', sortable: false },
          { text: 'FECHA', align: 'center' , value: 'created_at', sortable: false },
          { text: 'Acciones', align: 'center', sortable: false }
        ],
        rowsPerPageItems: [5, 10, 20, 50, 100]
      }
    },

    computed: {
        ...mapGetters({
            user: 'authUser'
        }),
        computedDateFormattedFecha () {
            return this.formatDate(this.form.payment_date)
        }
    },

    watch: {
        pagination() {
            this.getPaperByPagination();
        }
    },

    mounted () {
        this.$store.dispatch('clearMessage')
        this.$store.dispatch('fetchSatDocumentsType')
        this.getInfoCards()
    },

    methods: {

        async getInfoCards(){
            await axios.get(`/api/cliente/security-paper-client-status`)
                .then(res => {
                    this.banks = res.data.banks;
                    this.disponibles = res.data.disponibles.toString();
                    this.digital_disponible = res.data.digital_disponibles.toString();
                    this.digital_usados = res.data.digital_usados.toString();
                    this.usados = res.data.usados.toString();
                    this.precio_delivery = res.data.precio_delivery;
                })
        },

        diferenciaPago(props) {
            if(props.item.invoice.status == 'PENDIENTE'){
                let total = 0
                let count = 0
                let count2 = 0
                props.item.invoice.payments.forEach(pay => {
                    if(pay.agreement){
                        total += parseFloat(pay.amount)
                        count++
                    }else {
                        if(pay.observations != null){
                            count2++
                        }
                    }
                });

                if (total > 0) {
                    total = props.item.invoice.amount - total
                }

                if(count > 0 && parseFloat(props.item.invoice.amount) > total) {
                    return true
                }else if (count2 > 0) {
                    return true
                }

            }

            return false
        },

        montoDiferenciaPago(props) {
            let total = 0
            if(props.item.invoice.status == 'PENDIENTE'){
                props.item.invoice.payments.forEach(pay => {
                    if(pay.agreement){
                        total += parseFloat(pay.amount)
                    }
                });
            }

            if(props.item.invoice.status == 'PENDIENTE'){
                total = props.item.invoice.amount - total
            }

            return total
        },

        montoDiferenciaPago2(props) {
            let total = 0
            if(props.item.invoice.status == 'PENDIENTE'){
                props.item.invoice.payments.forEach(pay => {
                    if(pay.agreement){
                        total += parseFloat(pay.amount)
                    }
                });
            }

            return total
        },

        visulizarPapeles(props) {
            this.cantidadP = props.item.cantidad
            this.papersP = props.item
            this.dialogVisualizarPapers = true
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        getPaperByPagination() {
            this.loading = true;
            if (this.search) {
                axios.get(`/api/cliente/security-paper-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.papeles = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if (this.pagination.sortBy && !this.search) {
                const direction = this.pagination.descending ? 'desc' : 'asc';
                axios.get(`/api/cliente/security-paper-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.papeles = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if(!this.search && !this.pagination.sortBy) {
                axios.get(`/api/cliente/security-paper?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.papeles = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
        },

        async confirmData () {
            if (this.$refs.formpago.validate()) {
                this.loading = true
                let formData = new FormData();
                for (var key in this.form) {
                    formData.append(key, this.form[key]);
                }
                await axios.post(`/api/cliente/ap-pay-papel`,formData)
                    .then(res => {
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: 'Carga de pago Exitosa!..'
                        })
                        this.closePay()
                    })
                    .catch(error => {
                        console.log(error.response)
                        this.$store.dispatch('responseMessage', {
                            type: 'error',
                            text: 'Error, Intente mas Tarde'
                        })
                    })
                this.$nextTick(() => {
                    this.loading = false
                })
            }
        },

        async deleteItem (item) {
            let index = this.papeles.indexOf(item)
            let response = confirm('Estas seguro de eliminar esta SOLICITUD?')
            if(response){
                this.loading = true
                await axios.delete(`/api/cliente/security-paper-delete/${item.id}`)
                    .then(() => {
                       this.papeles.splice(index, 1);
                    })
                    .catch(error => {
                        console.log(error.response)
                    })
                    .finally(() => this.loading = false);
            }
        },

        onChange () {
            this.getPaperByPagination();
        },

        async changeWayToPay() {
            if(this.form.way_to_pay == 'EFECTIVO - MONEDA LOCAL'){
                this.form.number = null
            }
            if(this.form.way_to_pay == 'EFECTIVO - DIVISAS'){
                this.form.number = null
            }
        },

        async efectuarPago(props) {
            let tipo_hoja = props.item.digital ? 'DIGITAL' : 'FISICA'
            this.loading = true
            await axios.get(`/api/cliente/security-paper-mount/${tipo_hoja}`)//cambiar metodo para consultar saldo restante
                .then(resp => {
                    let precio = parseFloat(resp.data.monto_papeles) * props.item.cantidad
                    let se = parseFloat(resp.data.monto_servicio_electronico)
                   
                    let monto_total = precio + se
                    
                    this.form = {
                        invoice_id: props.item.invoice.id,
                        cpc: props.item.cpc,
                        amount: monto_total,
                        way_to_pay: 'TRANSFERENCIA',
                    }

                    this.$refs.formpago.resetValidation()
                    this.payActivate = true

                }).catch(err => {
                    console.log(err.response)
                    this.$refs.formpago.resetValidation()
                    this.payActivate = false
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'Error Servidor, Intente su pago mas tarde.'
                    })
                }).finally(() => this.loading = false)
        },

        onFocus() {
            this.$refs.fileInput.value = ''
            this.$refs.fileInput.click()
        },

        processFile(event) {
            let files = event.target.files || event.dataTransfer.files
            if (files[0].type == "image/png" || files[0].type == "image/jpg" || files[0].type == "image/jpeg" || files[0].type == "application/pdf") {
                this.form.file = files[0]
                this.nameImg = files[0].name
            }else {
                this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: 'El formato del documento debe ser PNG/JPG/JPEG o PDF'
                })
            }
        },

        async closePay() {
            this.form = {
                cpc: '',
                way_to_pay: 'TRANSFERENCIA',
                number: null,
                ruap_id: null,
                payment_date: '',
                observations: '',
                rif: '',
                razon_social: '',
                direccion_fiscal: '',
                agreement: false
            }
            this.payActivate = false
        },

        async responseForm(){
            this.getPaperByPagination();
        }

    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cliente/SolicitudPapeles.vue